import { getUser, getAccessToken } from './service/AuthService';
import { getUserGoal } from './service/GoalService';

import ProblematicLogEntry from './ProblematicLogEntry';

import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Checkbox.css';
import './css/Daily.css';
import './css/Timeline.css';
import './css/PopupForm.css';
import './css/Success.css';



const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';


const HomeDemo = () => {
    // console.log('getting user goal');
    // console.log(getUserGoal());
    

    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const user = getUser();
    //console.log(user)
    const token = getAccessToken();
    const goal = getUserGoal();
    const today = new Date()
    const navigate = useNavigate();
    let logHidden = true;

    const name = user !== 'undefined' && user ? user.name: '';
    const username = user !== 'undefined' && user ? user.username: '';

    const relapseHandler = (event) => {
        event.preventDefault();
        navigate('/relapse');

    }

    const learningHandler = (event) => {
        event.preventDefault();
        navigate('/daily-content');

    }

    const expandLog = () => {
        //console.log('clicked yo')
        if(logHidden){
            document.querySelector('#pastProblematicLog').classList.remove('display-none')
            document.querySelector('#logBttn').innerText = "Hide Past Problematc Use"
            logHidden = false
        }
        else{
            document.querySelector('#pastProblematicLog').classList.add('display-none')
            document.querySelector('#logBttn').innerText = "Show Past Problematc Use"
            logHidden = true
        }
    }

    useEffect(() => {
        // do stuff here...
        //console.log('here again')
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const moduleParams = {
            mode: 'default'
        };

        const requestBody = {
            username: user.username,
            token: token,
            module: moduleParams,
        }
        
        axios.post(logFetchUrl, requestBody, requestConfig).then(response => {
            //TODO: through here fetch the daily goal and the big long term goal as well
            //console.log('returned body')
            //console.log(`Status: ${response.status}`);
            //console.log('Body: ', response.data);
            //console.log('response')
            //console.log(response.data.dynamoContent[response.data.dynamoContent.length-1])
            setLastImpact(response.data.dynamoContent[response.data.dynamoContent.length-1].impact)
            setLastLesson('hard coded')
            setLastTitle(response.data.dynamoContent[response.data.dynamoContent.length-1].entryTitle)
            setLastDescription(response.data.dynamoContent[response.data.dynamoContent.length-1].entryDescription)            
            setLastSubmitDate(new Date(Number(response.data.dynamoContent[response.data.dynamoContent.length-1].sk)))
            for (let index = 0; index < response.data.dynamoContent.length; index++) {
                const entry = response.data.dynamoContent[index];
                entries.push(<hr></hr>)
                entries.push(<ProblematicLogEntry lastSubmitDate = {new Date(Number(entry.sk)).toString()} lastImpact= {entry.impact} lastLesson= {'hard coded'} entryDescription= {entry.entryDescription} entryTitle= {entry.entryTitle} />)
            }
            setEntryHTML(entries)
            //console.log(entries)

            // const responseObj = {}
            // for (let index = 0; index < response.data.dynamoContent.length; index++) {
            //     const element = response.data.dynamoContent[index];
            //     console.log(element)
            //     const objArr = element.sk.split("#")
            //     const objKey = objArr[0];
            //     if (objKey in responseObj){
            //         responseObj[objKey].push(element)
            //     }
            //     else{
            //         responseObj[objKey] = [element]
            //     }
            //     console.log(index)
            // }
            
            // setDailyContent(responseObj);
            // console.log(responseObj)
            // console.log(randomArrVal(responseObj['Learning']))

            // const dailyPrompt = randomArrVal(responseObj['Prompt'])
            // const dailyGoal = randomArrVal(responseObj['Goal'])
            // const dailyLearning = randomArrVal(responseObj['Learning'])

            // console.log('vars')
            // console.log(dailyLearning)
            // console.log(dailyGoal)
            // console.log(dailyPrompt)
            
            // setDailyLearning(dailyLearning)
            // setDailyPrompt(dailyPrompt)
            // setDailyGoal(dailyGoal)
            // setDailyGoalTitle(dailyGoal.textcontent)
            // setDailyGoalNotifications(dailyGoal.notifications)
            // //TODO: remove later -- for demonstration purposes
            // setDailyGoalNotifications("alert at 6:00pm")
            // if(dailyLearning.type === 'video'){
            //     setLearningContent( <Iframe source={ dailyLearning.url } />)
            // }
            // else{
            //     setLearningContent('<p>' + dailyLearning.textcontent +  '</p>')
            // }
            // setLoading(false);
        }).catch(error => {
            //TODO: fix error of receiving null error
            console.log('returned error')
            console.error(error);
            setErrorMessage('Sorry the server is down. Please try again later.');
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
    })
    }, []) 
    
    const todayString = today.toDateString();
    
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'center', padding:'1rem', marginTop: '4rem' }}>
            <div>
                <div className="headerContainer"  style={{ textAlign:'center' }}>
                    <h1 style={{ textAlign:'center' }}>Welcome Back, {username}</h1>
                    {/* <h3 className="container"> Digital Wellness is a Journey Not a Destination</h3> */}
                    {/* <p className="text-center"> The why: I will { user.currentGoal }</p> */}
                    <h4 className="text-center"> {username}'s big goal: get a promotion at work </h4>
                    {/* <h5 id="todayInfo"> Today: {todayString} </h5> */}
                    <div style={{ textAlign:'left' }}> 
                        <label class="check-container"> 
                            <div style={{ width:'90%' }}>🎯 daily goal: fill out your triggers / symptoms worksheet</div>
                            <input type="checkbox"/>
                            <span class="home-checkmark"></span>
                        </label>
                        <label class="check-container">
                            <div style={{ width:'90%' }}>🏃 daily workout: get your daily workout in - consistency is key</div>
                            <input type="checkbox"/>
                            <span class="home-checkmark"></span>
                        </label>
                    </div>
                </div>
                <div className="progressContainer" style={{ display:'flex' }}>
                    <div className="container">
                        <div className="item">
                            <span style={{ fontSize:'20px', fontWeight: 'bolder'  }}> Goals Completed </span>
                            <div style={{ marginTop:'1rem', fontSize:'28px', fontWeight: 'bold' }}> 4 </div>
                        </div>
                        {/* <div className="item">
                            <h4> Productive hours towards goal </h4>
                            <h2> 5 </h2>
                        </div> */}
                    </div>
                    <div className="container">
                        <div className="item">
                            <span style={{ fontSize:'20px', fontWeight: 'bolder'  }}> Workout Streak </span>
                            <div style={{ marginTop:'1rem', fontSize:'28px', fontWeight: 'bold' }}> 7 </div>
                        </div>
                        {/* <div className="item">
                            <h4> Productive hours towards goal </h4>
                            <h2> 5 </h2>
                        </div> */}
                    </div>
                    <div className="container">
                        <div className="item">
                            <span style={{ fontSize:'20px', fontWeight: 'bolder' }}> Wellness Streak </span><br/>
                            <div style={{ marginTop:'1rem', fontSize:'28px', fontWeight: 'bold'  }}> { Math.ceil((today - lastSubmitDate) / 8.64e7) } </div>
                        </div>
                        {/* <div className="item">
                            <h4> Productive hours towards goal </h4>
                            <h2> 5 </h2>
                        </div> */}
                    </div>
                </div>
                <div className="homeBttnContainer" style={{ display:'flex', flexDirection:'column', marginTop:"1.5rem" }}>
                    <button className="homeBttn" onClick={learningHandler}>Start your Workout</button>
                    <button className="homeBttn" style={{ marginTop:'1rem' }} >Feeling Overwhelmed</button>
                    <button className="homeBttn" style={{ marginTop:'1rem' }} >Get Back on Track</button>
                </div>
                {/* <div>
                    <div>
                        <h4> Last Problematic Use: { lastSubmitDate.toString() } </h4>
                        <p> { lastTitle } : { lastDescription } </p>
                        <div className="container">
                            <div className="item">
                                Key Lessons
                                <div className='left-text'>
                                    <p> { lastLesson } </p>
                                </div>
                            </div>
                            <div className="item">
                                Impact
                                <div>
                                    <p> { lastImpact } </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div> 
                        <button onClick= { expandLog } id="logBttn"> Show Past Problematic Use </button> 
                        <br></br>
                        <br></br>
                        <div className="display-none" id="pastProblematicLog">
                            { entryHTML }
                        </div>
                    </div>
                </div> */}
            </div>
            {errorMessage && <p className="message"> { errorMessage } </p>}
        </div>
    )
}

export default HomeDemo;